import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

/**
 * DS Pagination — 좌우 chevron + N개 페이지 cell.
 * Figma 시안에서는 최대 7개 cell 표시. 그 이상은 windowSize prop으로 조정.
 *
 * @param {object} props
 * @param {number} props.page - 현재 페이지 (1-base)
 * @param {number} props.totalPages
 * @param {(page: number) => void} props.onChange
 * @param {number} [props.windowSize=7]
 * @param {string} [props.className]
 */
const DSPagination = ({
  page,
  totalPages,
  onChange,
  windowSize = 7,
  className = "",
}) => {
  if (!totalPages || totalPages < 1) return null;

  // window calculation
  const half = Math.floor(windowSize / 2);
  let start = Math.max(1, page - half);
  let end = Math.min(totalPages, start + windowSize - 1);
  start = Math.max(1, end - windowSize + 1);

  const cells = [];
  for (let i = start; i <= end; i++) cells.push(i);

  const handleClick = (target) => {
    if (target < 1 || target > totalPages || target === page) return;
    onChange && onChange(target);
  };

  return (
    <div className={`ds-pagination ${className}`}>
      <button
        type="button"
        className={`ds-pagination__chevron ${
          page <= 1 ? "ds-pagination__cell--disabled" : ""
        }`}
        onClick={() => handleClick(page - 1)}
        aria-label="이전"
      >
        <FontAwesomeIcon icon={faAngleLeft} />
      </button>
      {cells.map((n) => (
        <button
          key={n}
          type="button"
          className={`ds-pagination__cell ${
            n === page ? "ds-pagination__cell--active" : ""
          }`}
          onClick={() => handleClick(n)}
          aria-current={n === page ? "page" : undefined}
        >
          {n}
        </button>
      ))}
      <button
        type="button"
        className={`ds-pagination__chevron ${
          page >= totalPages ? "ds-pagination__cell--disabled" : ""
        }`}
        onClick={() => handleClick(page + 1)}
        aria-label="다음"
      >
        <FontAwesomeIcon icon={faAngleRight} />
      </button>
    </div>
  );
};

export default React.memo(DSPagination);
